<template>
  <qx-card title="列表">
    <FillFreightDialog ref="fillFreightDialog" @sub="getData" />
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn
            :len="tableData.data.length"
            queryUrl="reportActionBO.ajax?cmd=expTenantOperate"
            :params="fullSearchData"
            bizName="车队运营报表报表导出"
            bizCode="exp202203"
            :excelKeys="excelKeys"
            :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            :height="tableHeight"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <el-table-column
              v-for="(item, index, key) in tableData.title"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.width || 150"
              :width="item.w"
              :fixed="item.fixed"
              align="center"
          >
            <template slot="header">
                  <span>
                    {{ item.label }}
                   <el-popover v-if="item.insertParent" placement="top-end" width="50" trigger="hover" popper-class="popoverBackB">
                     <div>订单处理：备注</div>
                    <i class="el-icon-question warning" slot="reference"></i>
                  </el-popover>
                  </span>
            </template>
            <template v-if="item.children">
              <el-table-column
                  v-for="(childItem, childIndex) in item.children"
                  :key="childIndex"
                  :prop="childItem.prop"
                  :label="childItem.label"
                  :min-width="childItem.width || 160"
                  :width="childItem.w"
              >
                <template slot="header">
                  <span>
                    {{ childItem.label }}
                   <el-popover v-if="childItem.insertParent" placement="top" width="300" trigger="hover" popper-class="popoverBackB">
                     <div>未完成：订单中存在“未上报”、“待审核”、“审核不通过”的费用项目，报表统计未完成，不作为最终参考值；</div>
                     <div>已完成：订单中各项费用均是“审核通过”，报表统计已完成。</div>
                    <i class="el-icon-question warning" slot="reference"></i>
                  </el-popover>
                  </span>
                </template>
                <section slot-scope="scope">
                  <section v-if="childItem.prop === 'sourceName'">
                    <span v-if="scope.row.sourceName === 'isTotal'"></span>
                    <span v-else>{{
                        scope.row[childItem.prop]
                      }}</span>
                  </section>
                  <section v-if="childItem.prop !== 'sourceName'" :class="{ error: scope.$index === 0 }">
                    <section v-if="childItem.prop === 'companyName'" @click="toDetail(scope.row)">
                      <span class="primary cur">{{ scope.row[childItem.prop] }}</span>
                    </section>
                    <section v-if="childItem.prop === 'reportState'">
                      <span class="green cur" v-if="scope.row.reportState === '已完成'">{{ scope.row[childItem.prop] }}</span>
                      <span class="orange cur" v-if="scope.row.reportState === '未完成'">{{ scope.row[childItem.prop] }}</span>
                    </section>
                    <!-- 应付运费 -->
                    <section
                        v-if="childItem.prop === 'fillFreightDouble' && scope.$index !== 0"
                        class="primary cur"
                        @click="showFillFreightDialog(scope.row)"
                    >
                      {{ scope.row[childItem.prop] }}
                    </section>
                    <section v-if="childItem.prop === 'fillFreightDouble' && scope.$index === 0">
                      {{ scope.row[childItem.prop] }}
                    </section>
                    <!-- 应付运费 -->
                    <section
                        v-if="childItem.prop !== 'companyName' && childItem.prop !== 'reportState' && childItem.prop !== 'fillFreightDouble' && scope.column.property !== 'remark'"
                    >{{ scope.row[childItem.prop] }}
                    </section>
                  </section>
                </section>
              </el-table-column>
            </template>

            <section slot-scope="scope">
              <section v-if="scope.column.property === 'profitStr'" :class="{ error: scope.$index === 0 }">
                <span>{{scope.row[scope.column.property]}}</span>
              </section>
                <!-- 备注信息 -->
                <section v-if="scope.column.property === 'remark'" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                  <span v-if="scope.row.remark && scope.row.remark.length < 10">{{scope.row[scope.column.property]}}</span>
                  <span v-if="scope.row.remark && scope.row.remark.length >= 10">
                    <el-popover placement="top-start" width="120" trigger="hover">
                    <div >
                      <p>{{ scope.row[scope.column.property]}}</p>
                    </div>
                    <span class="cur" slot="reference">{{scope.row[scope.column.property]}}</span>
                  </el-popover>
                  </span>
                </section>
                <!-- 备注信息 end -->
            </section>
          </el-table-column>
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.page"
              :page-sizes="[10, 20, 50]"
              :page-size="tableData.count"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import FillFreightDialog from './fillFreightDialog';
import {
  tenantOperateReport,
} from 'api/report';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    FillFreightDialog,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            label: '车辆运行基本资料',
            children: [
              {prop: 'orderId', label: '订单号码'},
              {prop: 'reportState', label: '报表状态', insertParent: 'reportState'},
              {prop: 'plateNumber', label: '车牌号码'},
              {prop: 'vehicleOrgIdName', label: '车辆归属部门'},
              {prop: 'vehicleRemark', label: '车辆备注'},
              {prop: 'vehicleInfo', label: '车型'},
              {prop: 'trailerNumber', label: '挂车车牌'},
              {prop: 'trailerType', label: '挂车车型'},
              {prop: 'orgIdName', label: '订单归属部门'},
              {prop: 'carDriverMan', label: '主驾'},
              {prop: 'copilotMan', label: '副驾'},
              {prop: 'drivingType', label: '单/双驾'},
              {prop: 'dependTimeStr', label: '发车/靠台时间'},
              {prop: 'companyName', label: '客户名称'},
              {prop: 'customerTypeName', label: '客户类型'},
              {prop: 'sourceName', label: '线路名称'},
              {prop: 'fillFreightDouble', label: '应付运费', w: 165},
            ],
          },
          {
            label: '车辆运行基本费用',
            children: [
              {prop: 'carPrepayMoneyDouble', label: '预支/借支款'},
              {prop: 'goVoyageFeeStr', label: '去程船费'},
              {prop: 'returnVoyageFeeStr', label: '回程船费'},
              {prop: 'islandEntryFeeStr', label: '进岛费'},
              {prop: 'highSpeedFeeStr', label: '现金过路费'},
              {prop: 'parkingFeeStr', label: '停车费'},
              {prop: 'maintenanceCostStr', label: '维修费'},
              {prop: 'cashForFuelOrGasStr', label: '现金加油/气费'},
              {prop: 'otherExpensesStr', label: '其他费用'},
              {prop: 'driverActualConsSumStr', label: '司机实销合计'},
            ],
          },
          {
            label: '油耗补助',
            children: [
              {prop: 'kilometreStr', label: '公里数（KM）'},
              {prop: 'actualOilConsumptionStr', label: '每公里实际消耗（L）'},
              {prop: 'standardOilConsumptionStr', label: '每公里规定标准（L）'},
              {prop: 'standardRiseStr', label: '规定燃油量（L）'},
              {prop: 'oilRiseStr', label: '实际加油升数（L）'},
              {prop: 'surplusRiseStr', label: '结余数量（L）'},
              {prop: 'mainDriverSubsidyStr', label: '主驾油补'},
              {prop: 'coDriverSubsidyStr', label: '副驾油补'},
              {prop: 'oilSubsidyStr', label: '本趟合计油补'},
            ],
          },
          {
            label: '气耗补助',
            children: [
              {prop: 'gasKilometreStr', label: '公里数（KM）'},
              {prop: 'gasActualConsPerKiloStr', width: '170px', label: '每公里实际消耗（KG）'},
              {prop: 'gasStandardConsPerKiloStr', width: '170px', label: '每公里标准气耗（KG）'},
              {prop: 'standardGasInjectionVolumeStr', width: '170px', label: '规定燃气量（KG）'},
              {prop: 'actualGasInjectionVolumeStr', label: '实际加气量（KG）'},
              {prop: 'surplusGasVolumeStr', width: '170px', label: '结余气量（KG）'},
              {prop: 'mainDriverGasSubsidyStr', label: '主驾气补'},
              {prop: 'coDriverGasSubsidyStr', label: '副驾气补'},
              {prop: 'gasSubsidyStr', label: '本趟合计气补'},
            ],
          },
          {
            label: '订单补助（工龄+安全+其他）',
            children: [
              {prop: 'mainDriverOrderSubsidyStr', label: '主驾订单补助'},
              {prop: 'mainSubsidyRemark', label: '主驾订单补助备注'},
              {prop: 'coDriverOrderSubsidyStr', label: '副驾订单补助'},
              {prop: 'coSubsidyRemark', label: '副驾订单补助备注'},
              {prop: 'driverOrderSubsidySumStr', label: '合计补助'},
            ],
          },
          {
            label: '订单扣款（时效+保险+其他）',
            children: [
              {prop: 'mainDriverOrderDeductionStr', label: '主驾订单扣款'},
              {prop: 'mainDeductionRemark', label: '主驾订单扣款备注'},
              {prop: 'coDriverOrderDeductionStr', label: '副驾订单扣款'},
              {prop: 'coDeductionRemark', label: '副驾订单扣款备注'},
              {prop: 'driverOrderDeductionSumStr', label: '合计扣款'},
            ],
          },
          {
            label: '司机服务费',
            children: [
              {prop: 'driverBaseSalaryDouble', label: '主驾基本服务费'},
              {prop: 'coDriverBaseSalaryDouble', label: '副驾基本服务费'},
              {prop: 'driverBaseSalarySumStr', label: '合计基本服务费'},
              {prop: 'currentFreightSumStr', label: '总服务费（合计+油补+气补+补助/扣款）'},
              {prop: 'balanceStr', label: '驾驶员出车款剩余金额'},
              {prop: 'mainDriverCurrentFreightStr', label: '支付主驾剩余服务费'},
              {prop: 'coDriverCurrentFreightStr', label: '支付副驾剩余服务费'},
              {prop: 'driverCurrentFreightSumStr', label: '支付驾驶员剩余总服务费'},
            ],
          },
          {prop: 'profitStr', label: '利润'},
          {prop: 'remark', label: '备注', w: 150, insertParent: 'remark'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: tenantOperateReport,
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核客户' : '客户详情',
        url: `/manage/archives/customer/archives/detail?id=${item.customerId}&type=${type}`,
        full: true,
      });
    },
    showFillFreightDialog (item) { // 应付运费
      this.$refs.fillFreightDialog.show(item);
    },
  },
};
</script>

<style scoped lang="scss">
.isTotal{
  color: red
}
</style>

<style lang="scss">
.el-popover.popoverBackB{
  background: #FFFF00 !important;
}
</style>
